import {EventEmitter, Injectable} from '@angular/core';
import {IHelpInfo} from '../models/i-help-info.interface';
import {EcaConfirmProcessService} from '../../shared/services/eca-confirm-process.service';
import {HelpInfoModalComponent} from '../modals/help-info-modal/help-info-modal.component';
import { EcaDynamicModalService } from "../../shared/services/eca-dynamic-modal-service";
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { IEcaDialogRef } from '../../shared/models/eca-dialog-ref.interface';

@Injectable({
  providedIn: 'root'
})

export class HelpModalService {
  modalRef: IEcaDialogRef;

  constructor(private confirmProcessService: EcaConfirmProcessService, private ecaDynamicModalService: EcaDynamicModalService) { }

  openHelpModal(helpInfo: IHelpInfo): EventEmitter<boolean> {

    let config = {
      styleClass: 'modal-notify modal-eca modal-xl',
      baseZIndex: 2000,
      showHeader: false,
      data: {
        helpInfo
      }
    } as DynamicDialogConfig;

    this.modalRef = this.ecaDynamicModalService.openDialog(HelpInfoModalComponent, config);
    return this.modalRef.content.answer;
  }
}


